// client/src/components/common/DragSelectOverlay.js
import React from 'react';

const DragSelectOverlay = ({ isDragging, dragRect }) => {
  if (!isDragging || !dragRect) return null;
  return (
    <div
      className="fixed border border-blue-400 bg-blue-500/10 rounded-sm pointer-events-none"
      style={{
        left: dragRect.left,
        top: dragRect.top,
        width: dragRect.right - dragRect.left,
        height: dragRect.bottom - dragRect.top,
        zIndex: 9999,
      }}
    />
  );
};

export default DragSelectOverlay;
